<script module lang="ts">
  // Poster/commenter "style" from a member's post↔comment mix. Single source of
  // truth so the members table, profile, and overview render it identically.
  export const STYLE_META: Record<string, { label: string; cls: string }> = {
    poster: { label: 'Poster', cls: 'bg-info/15 text-info' },
    commenter: { label: 'Commenter', cls: 'bg-success/15 text-success' },
    poster_commenter: { label: 'Poster & Commenter', cls: 'bg-base-content/10 text-base-content/72' },
  };
</script>

<script lang="ts">
  let { style, class: cls = '' }: { style: string | null | undefined; class?: string } = $props();
  const meta = $derived(style ? STYLE_META[style] : undefined);
</script>

{#if meta}
  <span class="inline-flex items-center rounded px-1.5 py-0.5 font-mono text-[0.65rem] {meta.cls} {cls}">{meta.label}</span>
{/if}
